<div class="row">
  <div class="col-4" *ngIf="title!=null"><label>{{title}}</label></div>
  <div [class.col-8]="title!=null" [class.col-12]="title==null">
    <div class="input-group input-group-sm">
      <!-- <input [(ngModel)]="dateValue" class="form-control form-control-sm" [placeholder]="title || 'Date'"
             [nbDatepicker]="formpicker"> -->
      <input [(ngModel)]="dateModel" class="form-control form-control-sm" [placeholder]="title || 'Date'"
            ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()" (dateSelect)="updateDate($event)">

      <div class="input-group-append">
        <button class="nrk-doc-button ml-2 mt-1" (click)="clear()">X</button>
      </div>
      <!-- <nb-datepicker #formpicker (dateChange)="update($event)" [date]="dateValue"></nb-datepicker> -->
    </div>
  </div>
</div>
